module.exports = __webpack_public_path__ + "static/media/wizualizacja-45.9be7c24d.png";